import { render, staticRenderFns } from "./Sancao.vue?vue&type=template&id=8addd0b8"
import script from "./Sancao.vue?vue&type=script&lang=js"
export * from "./Sancao.vue?vue&type=script&lang=js"
import style0 from "./Sancao.vue?vue&type=style&index=0&id=8addd0b8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports